import { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";

export default function Overview({ adminKey }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    adminApi
      .summary(adminKey)
      .then(setData)
      .catch((e) => setError(e.message));
  }, [adminKey]);

  if (error) {
    return <p role="alert" data-testid="overview-error" className="mt-10 font-mono text-xs text-red-400">{error}</p>;
  }
  if (!data) {
    return <p data-testid="overview-loading" className="mt-10 font-mono text-xs text-fog">LOADING…</p>;
  }

  const stats = [
    { v: String(data.total_visits), l: "TOTAL VISITS" },
    { v: String(data.unique_visitors), l: "UNIQUE VISITORS" },
    { v: String(data.total_inquiries), l: "INQUIRIES" },
    { v: `${data.conversion}%`, l: "VISIT → INQUIRY" },
    { v: `${data.visits_7d} / ${data.inquiries_7d}`, l: "LAST 7 DAYS — VISITS / INQUIRIES" },
  ];

  return (
    <div data-testid="admin-overview" className="mt-10">
      <div className="flex flex-wrap gap-x-14 gap-y-8 border-t border-white/10 pt-8">
        {stats.map(({ v, l }) => (
          <div key={l} data-testid="overview-stat">
            <p className="font-display text-3xl font-black tracking-tight text-white sm:text-4xl">{v}</p>
            <p className="mt-2 font-mono text-[10px] tracking-[0.25em] text-fog">{l}</p>
          </div>
        ))}
      </div>
      <p className="mt-10 font-mono text-[10px] leading-relaxed tracking-[0.2em] text-fog">
        CONVERSION = INQUIRIES ÷ UNIQUE VISITORS. VISITOR DATA IS ANONYMOUS UNTIL SOMEONE SENDS A MESSAGE.
      </p>
    </div>
  );
}
